import { render, staticRenderFns } from "./SimilarListOneToOne.vue?vue&type=template&id=4faf1377&scoped=true&"
import script from "./SimilarListOneToOne.vue?vue&type=script&lang=ts&"
export * from "./SimilarListOneToOne.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarListOneToOne.vue?vue&type=style&index=0&id=4faf1377&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf1377",
  null
  
)

export default component.exports